import React, {Fragment} from "react";
import {Link} from "react-router-dom";
import {getContactRouterLink} from "root/Wieldy/routePaths";
import {getDefaultContactViewPage} from "root/DataFunctions/PageContentRoles";
import {useGlobalContext} from "root/contexts/GlobalContext";
import {getDocumentUrl} from "root/DataFunctions/CommonDataFns";
import {UserTypes} from "root/DataFunctions/Constants";

import Floater from 'react-floater';

const ContactSidebarEntry = ({keyName, contact}) =>
{
    const { userType } = useGlobalContext() ;

    const defaultPage = getDefaultContactViewPage(userType);
    const contact_ut_id = Number(contact.user_type_id);

    const hide_user_image = (userType === UserTypes.BIRTH_PARENT || userType === UserTypes.OTHER)
        && (contact_ut_id === UserTypes.FOSTER_PARENT || contact_ut_id === UserTypes.FOREVER_PARENT);

    const getUserImage = () =>
    {
        const document_id = contact.document_id;

        //get the image if data and user is permitted to see image
        const url = document_id === null || hide_user_image ? '/images/defaultPerson.jpg': getDocumentUrl(document_id);

        return url
    }

    const floaterStyles = {
        container: {
            borderRadius: '10px',
            backgroundColor: '#dce8f1',
            zIndex: 1000
        },
        arrow: {
            color: '#dce8f1'
        },
    } ;

    const floaterText = () =>{
        const text = 'You have been blocked by this user. Please contact your ARCBOX administrator to discuss the reasons why.';
        return text;
    } ;

    return (
        <Fragment>
            {+contact.blocked === 0 && <Link to={getContactRouterLink(contact.user_id, defaultPage)} key={keyName}>
                <div className="child-menu-item">
                    <img alt="image" src={getUserImage()} width="50px" align="left"/>
                    <div style={{textAlign: 'left', alignSelf: 'center'}}>
                        <span>{contact.name}</span>
                    </div>

                </div>
            </Link>}

            {+contact.blocked === 1 &&
                <Floater content={floaterText()} event='hover' styles={{floaterStyles}}>
                    <div className="child-menu-item-blocked">
                        <img alt="image" src={getUserImage()} width="50px" align="left"/>

                        <div style={{textAlign: 'left', alignSelf: 'center'}}>
                            <span>{contact.name}</span><p className={'icon icon-exclamation icon-fw icon-lg'} style={{color: 'var(--s360-icon-red)'}}></p>
                        </div>
                    </div>
                </Floater>
            }
        </Fragment>
    )
}
export default ContactSidebarEntry;
